import React from "react";
import { Formik, Form, Field } from "formik";
import { Row, Col } from "reactstrap";
import { Button } from "zina-dogi-react";
import AsyncSelect from "react-select/async";
import { service as voaService } from "../redux";
import { service as vendorService } from "../../vendors/redux";

const filterValVoa = (key, val) => {
    return voaService
        .getVoas(1, {
            ...(val !== "" ? { [`${key}__icontains`]: val } : {})
        })
        .then(resp =>
            resp.list.map(val => {
                return {
                    value: val[key],
                    label: val[key]
                };
            })
        );
};
const filterVal = (key, val) => {
    return vendorService
        .getVendors(1, {
            ...(val !== "" ? { [`${key}__icontains`]: val } : {})
        })
        .then(resp =>
            resp.list.map(val => {
                return {
                    value: val.id,
                    label: `${val[key]} - ${val.legal_name}`
                };
            })
        );
};

const VoaFilter = ({ className, onSubmit = () => {}, ...props }) => {
    const comp_op = {
        className: ["voa_filters", className].join(" ")
    };
    const header = (
        <nav className="navbar">
            <span className="navbar-brand h4">VOA Management</span>
        </nav>
    );
    props.setheader(header);
    return (
        <div {...comp_op}>
            <div className="content">
                <Formik
                    initialValues={{
                        voa_number: null,
                        vendor: null
                    }}
                    enableReinitialize={true}
                    onSubmit={(values, cmp) => handleSubmit(onSubmit, values, cmp)}
                >
                    {props => {
                        const { values, setFieldValue } = props;
                        return (
                            <Form>
                                <Row>
                                    <Col sm="12" md="6">
                                        <div className="form-group">
                                            <label>VOA Number</label>
                                            <Field
                                                name="voa_number"
                                                value={values.voa_number}
                                                component={AsyncSelect}
                                                isClearable
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={val => filterValVoa("voa_number", val)}
                                                onChange={val => setFieldValue("voa_number", val, false)}
                                            />
                                        </div>
                                    </Col>
                                    <Col sm="12" md="6">
                                        <div className="form-group">
                                            <label>Vendor Code</label>
                                            <Field
                                                name="vendor_number"
                                                value={values.vendor}
                                                component={AsyncSelect}
                                                isClearable
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={val => filterVal("vendor_number", val)}
                                                onChange={val => setFieldValue("vendor", val, false)}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="controls">
                                    <Button type="reset" color="danger" icon="sync-alt">
                                        Clear filters
                                    </Button>
                                    <Button type="submit" color="primary" icon="filter">
                                        Filter
                                    </Button>
                                </Row>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </div>
    );
};

const handleSubmit = (submit, obj, { setSubmitting }) => {
    submit({
        ...(obj.voa_number ? { voa_number__iexact: obj.voa_number.value } : {}),
        ...(obj.vendor ? { vendor: obj.vendor.value } : {})
    });
    setSubmitting(false);
};

export default VoaFilter;
